<template>
  <div id="LpnPickS4" v-loading="loading">
    <v-container :left="true" :title="title" :height="'1.4rem'" @esc="esc">
      <template slot="content">
        <v-input :config="config" :models="models" :rules="rules" @complete="complete" ref="models"></v-input>
        <div style="overflow:hidden;padding:1em;line-height:1.8em;background:#fff">
          <div style="width:4em;float:left;">LPN</div>
          <ul style="margin-left:5em">
            <template v-for="item in lpnList">
              <li @click="enterClick(item)">
                <p style="line-height:1.8em">{{item}}</p>
              </li>
            </template>
          </ul>
        </div>
      </template>
      <v-foot :btn-config="btnConfig" @f4="f4" @f6="f6" slot="footer"></v-foot>
    </v-container>
  </div>
</template>

<script>
import container from '../../../commons/Container'
import input from '../../../commons/Input'
import foot from '../../../commons/Footer'
import baseMixin from '../../../../mixins/baseMixin'

export default {
  name: 'LpnPickS4',
  mixins: [baseMixin],
  data() {
    return {
      loading: false,
      title: this.$t('module.lpnPicktitle'),
      config: [
        { label: this.$t('module.loc'), prop: 'fromloc', disabled: true },
        { label: this.$t('module.SKU'), prop: 'sku', disabled: true }
        // {
        //   label: this.$t('module.LPN'),
        //   prop: 'lpn',
        //   inputType: 'textarea',
        //   height: '2rem',
        //   disabled: true
        // }
      ],
      models: {
        fromloc: '',
        sku: '',
        lpn: '',
        fromid: '',
        storerkey: '',
      },
      rules: {},
      page: 1,
      totalPage: 7,
      lpnList: []
    }
  },
  computed: {
    btnConfig() {
      return [
        {
          label: this.$t('module.page1', {
            page: this.page,
            totalPage: this.totalPage
          }),
          invalid: ''
        },
        {
          label: 'f4--' + this.$t('module.lastPage') + '',
          invalid: 'f4',
          authCode: 'RF02030401'
        },
        {
          label: 'f6--' + this.$t('module.nextPage') + '',
          invalid: 'f6',
          authCode: 'RF02030402'
        }
      ]
    }
  },
  methods: {
    esc() {
      this.$router.push({ name: 'LpnPickS2', params: this.models })
    },
    enterClick(lpn) {
      const lpndata = JSON.parse(sessionStorage.getItem('lpndata'))
      lpndata.toid = lpn;
      sessionStorage.setItem('lpndata', JSON.stringify(lpndata))
      this.$router.push({ name: 'LpnPickS2', params: this.models })
    },
    async complete(model, ref, callback) {},
    async f4() {
      if (this.page - 1 <= 0) {
        return
      }
      this.loading = true
      try {
        let res = await this.http.get(
          `/LpnPickQueryStockF2/${this.models.fromid}/${this.models.fromloc}/${
            this.models.storerkey
          }/${this.models.sku}/${this.page - 1}`
        )
        if (res.status == '200' && res.data.returnCode == '200') {
          const data = res.data.bean
          this.page = data.pagesize
          this.totalPage = data.countPage
          this.models.fromloc = data.fromloc
          this.models.sku = data.sku
          // this.models.lpn = data.lpn
          this.models.fromid = data.fromid
          this.models.storerkey = data.storerkey
          this.lpnList = this.models.lpn.split('\n').filter(i => i)
        } else {
          this.$message.error(res.data.returnMgr)
        }
      } catch (e) {
        this.$message.error(e)
      } finally {
        this.loading = false
      }
    },
    async f6() {
      this.loading = true
      try {
        if (this.totalPage <= this.page) {
          return
        }
        let res = await this.http.get(
          `/LpnPickQueryStockF2/${this.models.fromid}/${this.models.fromloc}/${
            this.models.storerkey
          }/${this.models.sku}/${this.page + 1}`
        )
        if (res.status == '200' && res.data.returnCode == '200') {
          this.page = res.data.bean.pagesize
          this.totalPage = res.data.bean.countPage
          this.models.fromloc = res.data.bean.fromloc
          this.models.sku = res.data.bean.sku
          // this.models.lpn = res.data.bean.lpn
          this.models.fromid = res.data.bean.fromid
          this.models.storerkey = res.data.bean.storerkey
          this.lpnList = this.models.lpn.split('\n').filter(i => i)
        } else {
          this.$message.error(res.data.returnMgr)
        }
      } catch (e) {
        this.$message.error(e)
      } finally {
        this.loading = false
      }
    },
    async complete(model, ref, callback) {}
  },
  mounted() {
    this.page = this.$route.params.data.pagesize
    this.totalPage = this.$route.params.data.countPage
    this.models.fromloc = this.$route.params.data.fromloc
    this.models.sku = this.$route.params.data.sku
    this.models.lpn = this.$route.params.data.lpn
    this.models.fromid = this.$route.params.data.fromid
    this.models.storerkey = this.$route.params.data.storerkey
    this.lpnList = this.models.lpn.split('\n').filter(i => i)
  },
  components: {
    'v-container': container,
    'v-input': input,
    'v-foot': foot
  }
}
</script>

<style scoped>
</style>
